import type { InputProps } from "@mui/material";
import { Input } from "@mui/material";
import classNames from "classnames";
import styles from "./styles.module.css";
import { forwardRef } from "react";

type Props = InputProps & {
  inputType?: "default" | "borderless";
  className?: string;
  inputClassName?: string;
};

export const AppNewInput = forwardRef<HTMLInputElement, Props>(
  (
    { inputType = "default", className, inputClassName, disabled, ...props },
    ref,
  ) => {
    const inputCls = classNames(styles.input, inputClassName);
    const wrapperCls = classNames(
      inputType === "default"
        ? styles["default-input"]
        : styles["borderless-input"],
      disabled && styles.disabled,
      className,
    );

    return (
      <Input
        fullWidth
        disableUnderline
        inputProps={{ ref }}
        classes={{
          input: inputCls,
        }}
        className={wrapperCls}
        disabled={disabled}
        {...props}
      />
    );
  },
);
